var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMonitor = function SvgMonitor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.764,
    height: 15.031,
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.764 2.016v8.065a2.015 2.015 0 0 1-2.016 2.016H2.016A2.015 2.015 0 0 1 0 10.082V2.016A2.015 2.015 0 0 1 2.016 0h11.732a2.015 2.015 0 0 1 2.016 2.016",
    "data-name": "Path 8663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.648 13.931a.55.55 0 0 1 0 1.1H3.116a.55.55 0 1 1 0-1.1Z",
    "data-name": "Path 8664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.899 12.831v1.65a.55.55 0 0 1-.55.55H6.416a.55.55 0 0 1-.55-.55v-1.65Z",
    "data-name": "Path 8665"
  }))));
};
export default SvgMonitor;